<template>
  <div class="file-upload-details">
    <b-loading :active="isLoading"></b-loading>

    <OmxPageHeader
        :title="pageTitle"
        :subtitle="$t('file-upload-details-view.subtitle')"
    />

    <OmxCard>
      <div class="file-upload-details__field">
        <label class="file-upload-details__label">{{ $t('file-upload-details-view.file-label') }}</label>
        <b-field class="file" :class="{ 'has-name': !!selectedFile }">
          <b-upload v-model="selectedFile" class="file-label"
                    accept=".jpg, .jpeg, .png, .pdf, .txt, .zip, .doc, .docx, .xls, .xlsx, .ppt, .pptx, .rtf"
                    @input="onFileSelected">
            <span class="file-cta">
              <b-icon class="file-icon" icon="upload"></b-icon>
              <span class="file-label">{{ $t('file-upload-details-view.select-file-button') }}</span>
            </span>
            <span class="file-name" v-if="selectedFile">
              {{ selectedFile.name }}
            </span>
          </b-upload>
          <b-button v-if="isFileSelected" type="is-danger" icon-left="delete"
                    @click="onFileRemoveSelected" />
        </b-field>
        <p v-if="!selectedFile" class="file-upload-details__help">
          {{ $t('file-upload-details-view.file-allowed-size') }}<br/>
          {{ $t('file-upload-details-view.file-allowed-type') }}
        </p>
      </div>

      <OmxField
          type="textarea"
          v-model="fileDescription"
          :label="$t('file-upload-details-view.description-text-field')"
          :placeholder="$t('personal-details-view.personal-text-placeholder')"
          tabindex="16"
      />

      <template #foot>
        <div class="file-upload-details__actions">
          <b-button icon-left="close-thick" tabindex="31" @click="cancelClicked">
            {{ $t('common.cancel') }}
          </b-button>
          <OmxPermissionButton
              :allowed="currentUserAccess('ProjectFilesDetails', UserActions.UPDATE, project_id)"
              type="is-primary" icon-left="content-save" tabindex="32"
              @click="uploadClicked">
            {{ $t('file-upload-details-view.upload-button') }}
          </OmxPermissionButton>
        </div>
      </template>
    </OmxCard>
  </div>
</template>

<script>
import firebase from "firebase";
import OmxPageHeader from "@/components/OmxPageHeader.vue";
import OmxCard from "@/components/OmxCard.vue";
import OmxField from "@/components/OmxField.vue";

export default {
  name: "FileUploadDetails",
  components: { OmxPageHeader, OmxCard, OmxField },
  props: {
    'project_id': {
      type: String
    }
  },
  data() {
    return {
      selectedFile: null,
      fileDescription: "",
      isLoading: false
    }
  },
  methods: {
    onFileSelected() { /* no-op; selection is reactive */ },
    onFileRemoveSelected() {
      this.selectedFile = null
    },
    uploadFile() {
      if (this.selectedFile !== null && this.selectedFile !== undefined) {
        this.isLoading = true;
        const userEmail = firebase.auth().currentUser.email
        const metadata = {
          customMetadata: {
            description: this.fileDescription,
            email: userEmail
          }
        };
        this.getFileRef().put(this.selectedFile, metadata).then(() => {
          this.isLoading = false;
          this.$emit('fileUploaded');
        }).catch((error) => {
          this.isLoading = false;
          this.showError(error.message)
        });
      }
    },
    getFileRef() {
      const filePath = this.getStorageRootFolder() + '/projects/' + this.project_id + '/files/' + this.selectedFile.name
      return firebase.storage().ref(filePath)
    },
    cancelClicked() {
      this.$emit('close');
    },
    uploadClicked() {
      this.uploadFile()
    }
  },
  computed: {
    isFileSelected() {
      return this.selectedFile !== null && this.selectedFile !== undefined && this.selectedFile !== "";
    },
    pageTitle() {
      return this.$t('file-upload-details-view.title')
    }
  }
};
</script>

<style scoped lang="scss">
@import "@/assets/scss/tokens";

.file-upload-details {
  display: flex;
  flex-direction: column;
  gap: 16px;
}

.file-upload-details__field {
  margin-bottom: 16px;
}

.file-upload-details__label {
  display: block;
  font-size: 12px;
  font-weight: 600;
  color: $omx-ink-700;
  margin-bottom: 6px;
  letter-spacing: .01em;
}

.file-upload-details__help {
  margin: 6px 0 0;
  font-size: 12px;
  color: $omx-ink-500;
  line-height: 1.5;
}

.file-upload-details__actions {
  display: flex;
  gap: 8px;
  justify-content: flex-end;
  flex-wrap: wrap;
}
</style>
